import { colors } from "@/styles/colors"
import ColorUtil from "@/utils/ColorUtil"
import { makeStyles } from "@material-ui/core"

const useStyles = makeStyles(theme => ({
	contactFilterItem: {
		"&:hover": {
			textDecoration: "underline"
		},
		marginTop: theme.spacing(0.5),
		color: colors.blue[700],
		cursor: "pointer"
	},
	iconButton: {
		background: colors.gray[100],
		opacity: 0.8,
		borderRadius: "8px",
		gap: "8px",
		"&:hover": {
			...ColorUtil.getBackgroundAndContrastColor(colors.gray[200])
		},
		width: "64px",
		height: "64px",
		color: colors.gray[700],
		fontSize: "20px",
		cursor: "pointer"
	},
	listItemDescriptionKey: {
		flex: 1,
		fontSize: "18px",
		fontWeight: 800
	},
	listItemDescriptionValue: {
		opacity: 0.85,
		fontSize: "16px",
		fontWeight: 300
	},
	listItemIcon: {
		color: colors.gray[700],
		fontSize: "20px"
	},
	title: {
		overflow: "hidden",
		textOverflow: "ellipsis",
		whiteSpace: "nowrap",
		display: "block"
	}
}))

export default useStyles
